module.exports = __webpack_public_path__ + "assets/img/onekonggou_4.7fa05878.jpg";